var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchGrayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 0C2.08934 0 0 2.08934 0 4.66667C0 7.244 2.08934 9.33333 4.66667 9.33333C5.71489 9.33333 6.68239 8.98773 7.46145 8.40426L10.1953 11.1381C10.4557 11.3985 10.8778 11.3985 11.1381 11.1381C11.3985 10.8778 11.3985 10.4557 11.1381 10.1953L8.40426 7.46145C8.98773 6.68239 9.33333 5.71489 9.33333 4.66667C9.33333 2.08934 7.244 0 4.66667 0ZM1.33333 4.66667C1.33333 2.82572 2.82572 1.33333 4.66667 1.33333C6.50762 1.33333 8 2.82572 8 4.66667C8 6.50762 6.50762 8 4.66667 8C2.82572 8 1.33333 6.50762 1.33333 4.66667Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGrayIcon);
export default __webpack_public_path__ + "static/media/search-gray-icon.8f3559bb5952a75d8b1356db66b5232f.svg";
export { ForwardRef as ReactComponent };